export default "__VITE_ASSET__FWK9yz3C__"